import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Category } from '@/types/category'

export function updateCategory(
  body: Category
): Promise<AxiosResponse<Category>> {
  return instance.put(`/category/${body.uuid}`, body)
}
